export default __webpack_public_path__ + "static/media/mobileIcon.cd3a33d1.svg";